// extracted by mini-css-extract-plugin
module.exports = {"container":"CardQuestion_container__2kp_O","footer":"CardQuestion_footer__oCmRI","btns":"CardQuestion_btns__1aRtO"};